<template>
  <div id="fuel-consumption-detail">
    <div class="vx-card p-6 list-container">
      <div class="input-area">
        <div class="vessel-name-area">
          <div class="vessel-name-text aisea-text-18-400-black">
            {{ vesselName }}
          </div>
          <router-link
            :to="{ name: 'addon-eco-ship-fuel-consumption-list' }"
            class="back-to-list-button"
          >
            <feather-icon icon="ChevronLeftIcon" svgClasses="h-5 w-5" />
            <span>一覧へ戻る</span>
          </router-link>
        </div>
        <vs-row class="input-group">
          <vs-col class="input-column left-column" vs-lg="5">
            <vs-col class="departure-col" vs-lg="12">
              <vs-col class="departure-box-area" vs-lg="4">
                <div class="departure-box">
                  <span class="box-text aisea-text-16-400-white"> {{departurePortName}} </span>
                </div>
              </vs-col>
              <vs-col class="departure-info-area" vs-lg="8">
                <vs-col class="departure-date" vs-lg="12">
                  <vs-col class="aisea-text-14-700-dark-gray" vs-lg="3">出港日</vs-col>
                  <vs-col v-if="departureDate != null" class="aisea-text-14-700-black" vs-lg="9"> {{departureDate}} </vs-col>
                  <span v-else> - </span>
                </vs-col>
                <vs-col class="departure-time" vs-lg="12">
                  <vs-col class="aisea-text-14-700-dark-gray" vs-lg="3">出港時間</vs-col>
                  <vs-col v-if="departureTime != null" class="aisea-text-14-700-black" vs-lg="9"> {{departureTime}} </vs-col>
                  <span v-else> - </span>
                </vs-col>
              </vs-col>
            </vs-col>
            <vs-col class="progress-arrow-col" vs-lg="12">
              <div class="progress-arrow arrow-style"></div>
            </vs-col>
            <vs-col class="arrival-port-col" vs-lg="12">
              <vs-col class="arrival-port-box-area" vs-lg="4">
                <div class="arrival-port-box">
                  <span class="box-text aisea-text-16-400-black"> {{arrivalPortName}} </span>
                </div>
              </vs-col>
              <vs-col class="arrival-port-info-area" vs-lg="8">
                <vs-col class="arrival-port-date" vs-lg="12">
                  <vs-col class="aisea-text-14-700-dark-gray" vs-lg="3">入港日</vs-col>
                  <vs-col v-if="arrivalPortDate != null" class="aisea-text-14-700-black" vs-lg="9"> {{arrivalPortDate}} </vs-col>
                  <span v-else> - </span>
                </vs-col>
                <vs-col class="arrival-port-time" vs-lg="12">
                  <vs-col class="aisea-text-14-700-dark-gray" vs-lg="3">入港時間</vs-col>
                  <vs-col v-if="arrivalPortTime != null" class="aisea-text-14-700-black" vs-lg="9"> {{arrivalPortTime}} </vs-col>
                  <span v-else> - </span>
                </vs-col>
              </vs-col>
            </vs-col>
          </vs-col>
          <vs-col class="input-column right-column" vs-lg="7">
            <vs-col class="engine-speed-col" vs-lg="12">
              <vs-col class="pitch-area" vs-lg="6">
                <vs-col class="pitch-title" vs-lg="7">
                  <span class="aisea-text-14-700-dark-gray">平均ピッチ</span>
                </vs-col>
                <vs-col class="pitch-value" vs-lg="5">
                  <span v-if="averagePitch != null" class="aisea-text-14-400-black">{{averagePitch}} min-1</span>
                  <span v-else> - </span>
                </vs-col>
              </vs-col>
              <vs-col class="main-engine-speed-area" vs-lg="6">
                <vs-col class="main-engine-speed-text" vs-lg="7">
                  <span class="aisea-text-14-700-dark-gray">主機回転数</span>
                </vs-col>
                <vs-col class="main-engine-speed-value" vs-lg="5">
                  <span v-if="rotationCount != null" class="aisea-text-14-400-black">{{rotationCount}} REV</span>
                  <span v-else> - </span>
                </vs-col>
              </vs-col>
            </vs-col>
            <vs-col class="heavy-oil-consumption-col" vs-lg="12">
              <vs-col class="avelage-c-heavy-oil-area" vs-lg="6">
                <vs-col class="avelage-c-heavy-oil-text" vs-lg="7">
                  <span class="aisea-text-14-700-dark-gray">平均C重油消費量</span>
                </vs-col>
                <vs-col class="avelage-c-heavy-oil-value" vs-lg="5">
                  <span v-if="averageCfo != null" class="aisea-text-14-400-black">{{averageCfo}} L/H</span>
                  <span v-else> - </span>
                </vs-col>
              </vs-col>
              <vs-col class="heavy-oil-consumption-area" vs-lg="6">
                <vs-col class="c-heavy-oil-area" vs-lg="12">
                  <vs-col class="c-heavy-oil-text" vs-lg="7">
                    <span class="aisea-text-14-700-dark-gray">C重油消費量</span>
                  </vs-col>
                  <vs-col class="c-heavy-oil-value" vs-lg="5">
                    <span v-if="cFuelConsumption != null" class="aisea-text-14-400-black">{{cFuelConsumption}} L</span>
                    <span v-else> - </span>
                  </vs-col>
                </vs-col>
                <vs-col class="a-heavy-oil-main-area" vs-lg="12">
                  <vs-col class="a-heavy-oil-main-text" vs-lg="7">
                    <span class="aisea-text-14-700-dark-gray">A重油消費量：主機</span>
                  </vs-col>
                  <vs-col class="a-heavy-oil-main-value" vs-lg="5">
                    <span v-if="aFuelMain != null" class="aisea-text-14-400-black">{{aFuelMain}} L</span>
                    <span v-else> - </span>
                  </vs-col>
                </vs-col>
                <vs-col class="a-heavy-oil-sub-area" vs-lg="12">
                  <vs-col class="a-heavy-oil-sub-text" vs-lg="7">
                    <span class="aisea-text-14-700-dark-gray">A重油消費量：補機</span>
                  </vs-col>
                  <vs-col class="a-heavy-oil-sub-value" vs-lg="5">
                    <span v-if="aFuelSub != null" class="aisea-text-14-400-black">{{aFuelSub}} L</span>
                    <span v-else> - </span>
                  </vs-col>
                </vs-col>
              </vs-col>
            </vs-col>
            <vs-col class="vessel-report-col" vs-lg="12">
              <vs-col class="vessel-speed-area" vs-lg="6">
                <vs-col class="vessel-speed-text" vs-lg="7">
                  <span class="aisea-text-14-700-dark-gray">平均船速</span>
                </vs-col>
                <vs-col class="vessel-speed-value" vs-lg="5">
                  <span v-if="averageSpeed != null" class="aisea-text-14-400-black">{{averageSpeed}} kn</span>
                  <span v-else> - </span>
                </vs-col>
              </vs-col>
              <vs-col class="voyage-history-area" vs-lg="6">
                <vs-col class="voyage-distance-area" vs-lg="12">
                  <vs-col class="voyage-distance-text" vs-lg="7">
                    <span class="aisea-text-14-700-dark-gray">航海距離</span>
                  </vs-col>
                  <vs-col class="voyage-distance-value" vs-lg="5">
                    <span v-if="totalDistance != null" class="aisea-text-14-400-black">{{totalDistance}} mile</span>
                    <span v-else> - </span>
                  </vs-col>
                </vs-col>
                <vs-col class="voyage-time-area" vs-lg="12">
                  <vs-col class="voyage-time-text" vs-lg="7">
                    <span class="aisea-text-14-700-dark-gray">航海時間</span>
                  </vs-col>
                  <vs-col class="voyage-time-value" vs-lg="5">
                    <span v-if="totalTime != null" class="aisea-text-14-400-black">{{totalTime}}</span>
                    <span v-else> - </span>
                  </vs-col>
                </vs-col>
              </vs-col>
            </vs-col>
            <vs-col class="weather-col" vs-lg="12">
              <vs-col class="weather-area" vs-lg="6">
                <vs-col class="weather-text" vs-lg="7">
                  <span class="aisea-text-14-700-dark-gray">天候</span>
                </vs-col>
                <vs-col class="weather-value" vs-lg="5">
                  <span v-if="weather != null" class="aisea-text-14-400-black">{{weather}}</span>
                  <span v-else> - </span>
                </vs-col>
              </vs-col>
              <vs-col class="weather-info-area" vs-lg="6">
                <vs-col class="wind-direction-area" vs-lg="12">
                  <vs-col class="wind-direction-text" vs-lg="7">
                    <span class="aisea-text-14-700-dark-gray">風向</span>
                  </vs-col>
                  <vs-col class="wind-direction-value" vs-lg="5">
                    <span v-if="windDirection != null" class="aisea-text-14-400-black">{{windDirection}}</span>
                    <span v-else> - </span>
                  </vs-col>
                </vs-col>
                <vs-col class="wind-power-area" vs-lg="12">
                  <vs-col class="wind-power-text" vs-lg="7">
                    <span class="aisea-text-14-700-dark-gray">風力</span>
                  </vs-col>
                  <vs-col class="wind-power-value" vs-lg="5">
                    <span v-if="windStrength != null" class="aisea-text-14-400-black">{{windStrength}} m/s</span>
                    <span v-else> - </span>
                  </vs-col>
                </vs-col>
                <vs-col class="wave-height-area" vs-lg="12">
                  <vs-col class="wave-height-text" vs-lg="7">
                    <span class="aisea-text-14-700-dark-gray">波高</span>
                  </vs-col>
                  <vs-col class="wave-height-value" vs-lg="5">
                    <span v-if="waveHeight != null" class="aisea-text-14-400-black">{{waveHeight}} m</span>
                    <span v-else> - </span>
                  </vs-col>
                </vs-col>
                <vs-col class="swell-area" vs-lg="12">
                  <vs-col class="swell-text" vs-lg="7">
                    <span class="aisea-text-14-700-dark-gray">うねり</span>
                  </vs-col>
                  <vs-col class="swell-value" vs-lg="5">
                    <span v-if="swell != null" class="aisea-text-14-400-black">{{swell}} m</span>
                    <span v-else> - </span>
                  </vs-col>
                </vs-col>
                <vs-col class="visibility-area" vs-lg="12">
                  <vs-col class="visibility-text" vs-lg="7">
                    <span class="aisea-text-14-700-dark-gray">視程</span>
                  </vs-col>
                  <vs-col class="visibility-value" vs-lg="5">
                    <span v-if="visibility != null" class="aisea-text-14-400-black">{{visibility}} NM</span>
                    <span v-else> - </span>
                  </vs-col>
                </vs-col>
              </vs-col>
            </vs-col>
          </vs-col>
        </vs-row>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import moment from "moment";
import { DeviceInfoMixin, ColorMixin } from "@/mixins";

const { mapState, mapActions } = createNamespacedHelpers("ecoShip");

export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  data() {
    return {
      vesselName: null,
      departurePortName: null,
      departureDate: null,
      departureTime: null,
      arrivalPortName: null,
      arrivalPortDate: null,
      arrivalPortTime: null,
      averagePitch: null,
      rotationCount: null,
      averageCfo: null,
      cFuelConsumption: null,
      aFuelMain: null,
      aFuelSub: null,
      averageSpeed: null,
      totalDistance: null,
      totalTime: null,
      weather: null,
      windDirection: null,
      windStrength: null,
      waveHeight: null,
      swell: null,
      visibility: null,
    };
  },
  watch: {

  },
  async created() {
    this.fetchFuelDetail();
  },
  computed: {
    ...mapState({
      voyageHistoryDetail: state => state.voyageHistoryDetail,
    })
  },
  methods: {
    ...mapActions([
      "fetchVoyageHistoryDetail",
      "fetchReports"
    ]),
    async fetchFuelDetail() {

      this.$vs.loading();

      this.vesselName = this.voyageHistoryDetail.vesselName;

      let rangeDate = null;
      if (this.voyageHistoryDetail.startedAt != null && this.voyageHistoryDetail.endedAt != null) {
        rangeDate = moment(this.voyageHistoryDetail.startedAt).utc().format("YYYY/MM/DD") + "-" + moment(this.voyageHistoryDetail.endedAt).utc().format("YYYY/MM/DD");
      }

      let payload = {
        vessel_id: this.voyageHistoryDetail.vesselId,
        voyage_history_id: this.voyageHistoryDetail.voyageId,
        params: {
          range_date: rangeDate,
        }
      }

      let voyageHistoryRes = await this.fetchVoyageHistoryDetail(payload);
      let vesselReportRes = await this.fetchReports(payload);

      if (voyageHistoryRes.properties) {
        let routeName = voyageHistoryRes.properties.route_name ? voyageHistoryRes.properties.route_name.split("-") : null;
        this.departurePortName = voyageHistoryRes.properties.route_name ? routeName[0] : null;
        this.arrivalPortName = voyageHistoryRes.properties.route_name ? routeName[1] : null;
        this.departureDate = voyageHistoryRes.started_at ? moment(voyageHistoryRes.started_at).format("MM月DD日") : null;
        this.departureTime = voyageHistoryRes.started_at ? moment(voyageHistoryRes.started_at).format("HH:mm") : null;
        this.arrivalPortDate = voyageHistoryRes.ended_at ? moment(voyageHistoryRes.ended_at).format("MM月DD日") : null;
        this.arrivalPortTime = voyageHistoryRes.ended_at ? moment(voyageHistoryRes.ended_at).format("HH:mm") : null;
        this.averagePitch = (voyageHistoryRes.properties.er_average_pitch != null) ? voyageHistoryRes.properties.er_average_pitch.toFixed(0) : null;
        this.rotationCount = (voyageHistoryRes.properties.er_rotation_count != null) ? voyageHistoryRes.properties.er_rotation_count.toLocaleString() : null;
        this.averageCfo = (voyageHistoryRes.properties.er_average_cfo_consumption != null) ? voyageHistoryRes.properties.er_average_cfo_consumption.toFixed(2) : null;
        this.cFuelConsumption = (voyageHistoryRes.properties.er_c_fuel_consumption != null) ? voyageHistoryRes.properties.er_c_fuel_consumption.toLocaleString() : null;
        this.aFuelMain = (voyageHistoryRes.properties.er_a_fuel_consumption != null) ? voyageHistoryRes.properties.er_a_fuel_consumption.toLocaleString() : null;
        this.aFuelSub = (voyageHistoryRes.properties.er_power_generation_fuel_consumption != null) ? voyageHistoryRes.properties.er_power_generation_fuel_consumption.toLocaleString() : null;
        this.averageSpeed = (voyageHistoryRes.properties.er_average_speed != null) ? Number(voyageHistoryRes.properties.er_average_speed).toFixed(2) : null;
        this.totalDistance = (voyageHistoryRes.properties.er_total_distance != null) ? Number(voyageHistoryRes.properties.er_total_distance).toFixed(3) : null;
        this.totalTime = (voyageHistoryRes.ended_at != null && voyageHistoryRes.started_at != null) ? this.totalTimeCreate(voyageHistoryRes.ended_at, voyageHistoryRes.started_at) : null;
      }

      if (vesselReportRes.reports.length) {

        if (this.voyageHistoryDetail.startedAt <= vesselReportRes.reports[0].report_at && vesselReportRes.reports[0].report_at <= this.voyageHistoryDetail.endedAt) {
          this.weather = vesselReportRes.reports[0].weather;
          this.windDirection = vesselReportRes.reports[0].wind_direction;
          this.windStrength = vesselReportRes.reports[0].wind_strength;
          this.waveHeight = vesselReportRes.reports[0].wave_height;
          this.swell = vesselReportRes.reports[0].swell;
          this.visibility = Math.round(vesselReportRes.reports[0].visibility * 100 / 1852) / 100;
        }
      }

      this.$vs.loading.close();
    },
    totalTimeCreate(endedAt, startedAt) {
      let diff = moment(endedAt).diff(moment(startedAt));
      let hours = Math.floor(diff / 1000 / 3600);
      let minutes = Math.floor(diff / 1000 / 60) % 60;
      let totalTimeValue = hours + "時間" + minutes + "分";
      return totalTimeValue;
    }

  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
#fuel-consumption-detail {
  .input-area {
    width: 100%;
  }
  .vessel-name-area {
    display: flex;
    align-items: center;
    .back-to-list-button {
      height: 20px;
      cursor: pointer;
      color: $aisea-blue !important;
    }
    .vessel-name-text {
      margin-right: 20px;
    }
  }
  .back-to-list-button {
    display: flex;
  }
  .input-group {
    width: 100%;
    display: flex;
    padding: 1.5rem 0.5rem;
  }
  .input-column {
    width: 400px;
  }
  .departure-box {
    width: 110px;
    height: auto;
    display: inline-block;
    text-align: center;
    background: $aisea-blue;
    border-radius: 5px;
  }
  .box-text {
    display: inline-block;
    width: 90px;
    padding: 3px 0px;
    overflow-wrap: break-word;
  }
  .arrival-port-box {
    width: 110px;
    height: auto;
    display: inline-block;
    text-align: center;
    background: $aisea-pure-white;
    border: solid 1px $aisea-gray-black;
    border-radius: 5px;
  }
  .progress-arrow {
    position: relative;
    display: inline-block;
    padding: 0 0 0 16px;
    color: #000;
    vertical-align: middle;
    text-decoration: none;
    font-size: 15px;
    margin-top: 230px;
  }
  .progress-arrow::before,
  .progress-arrow::after {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    content: "";
    vertical-align: middle;
  }
  .arrow-style::before {
    width: 170px;
    height: 2px;
    background: $aisea-gray;
    transform: rotate(90deg);
    margin-bottom: 110px;
    margin-left: -30px;
  }
  .arrow-style::after {
    left: 50px;
    width: 8px;
    height: 8px;
    border-right: 2px solid $aisea-gray;
    border-bottom: 2px solid $aisea-gray;
    transform: rotate(45deg);
    margin-bottom: 25px;
  }
  .engine-speed-col {
    border-top: solid 1px $aisea-mouse-gray;
  }
  .engine-speed-col, .heavy-oil-consumption-col,
  .vessel-report-col, .weather-col {
    border-bottom: solid 1px $aisea-mouse-gray;
    padding: 1rem 0rem;
  }
  .c-heavy-oil-area, .a-heavy-oil-main-area,
  .voyage-distance-area, .wind-direction-area,
  .wind-power-area, .wave-height-area, .swell-area {
    padding-bottom: 1rem;
  }

}
</style>
